export default "__VITE_ASSET__UU__C3Kg__ 333w";